import React from 'react';
import './Hero.css';
import DigitalMarketingVideo from '../Assets/digitalmarketing.mp4';

function Hero() {
  return (
    <section className="hero-angled">
      {/* RIGHT SIDE VIDEO */}
      <video
        className="hero-video-bg"
        src={DigitalMarketingVideo}
        autoPlay
        muted
        loop
        playsInline
      />

      <div className="hero-wrap">
        {/* LEFT COPY */}
        <div className="hero-copy">
          <h1 className="hero-title">
            Grow Your <span className="highlight">Brand</span>
            <br />
            with Stunning Visuals & Marketing
          </h1>

          <p className="hero-subtitle">
            We design logos, websites, posters, and ad campaigns that shine so
            your business can too.
          </p>

          <a href="#contact" className="cta-button-yellow">
            Get a Free Quote
          </a>
        </div>

        {/* spacer column */}
        <div className="hero-right" aria-hidden="true" />
      </div>

      {/* CURVED BOTTOM */}
      <svg
        className="hero-divider"
        viewBox="0 0 1440 140"
        preserveAspectRatio="none"
      >
        <path
          d="M0,96 C240,160 480,160 720,120 C960,80 1200,40 1440,64 L1440,140 L0,140 Z"
          fill="#ffffff"
        />
      </svg>
    </section>
  );
}

export default Hero;
